import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Protocolocero.css";
import { protocoloCero } from "../../json/protocoloCero";

const ProtocoloCero = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container informacion-container">
      <div className="row">
        <div className="col-12">
          <div className="informacion_title">
            <h1>Protocolo Cero</h1>
          </div>
        </div>
      </div>
      <div className="row">
      <p>El Protocolo Cero establece medidas específicas para prevenir conductas de acoso sexual y/o laboral y hostigamiento sexual y/o laboral en las Dependencias y Entidades de la Administración Pública Estatal, así como promover una cultura Institucional de igualdad de género y un clima laboral libre de violencia.</p>
        {protocoloCero.map((item, index) => (
          <div className="col-sm-4 d-flex align-items-stretch" > 
          <div className="card w-100">  
            <div className="card-header"><img src={item.img_url} class="card-img-top" alt="..."></img></div>
                <div className="card-body text-justify" >
                     <label className="mx-3 text-justify my-3">
                       {item.id_item}
                     </label> 
                     <ul className="list-group list-group-flush">
                       {" "}
                         {item.titulos_array.map((proto, i) => (
                              <li className="list-group-item" > <a href={proto.link_item_url} target="_blank">{proto.link_item_nombre}</a></li> 
                         ))}{" "}
                       </ul> 
                 </div>
              
          </div>
       </div>
        ))}
      </div>
    </div>
  );
};

export default ProtocoloCero;
